module.exports = __webpack_public_path__ + "img/whole_header_pc.6cdef11b.jpg";